<template>
  <div id="pageItemList">
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          <v-icon>build</v-icon>
          {{ title }}
        </h3>
      </div>
      <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
    </v-layout>
    <v-form ref="editCreateForm">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
            <v-stepper v-model="stepper" vertical non-linear>
              <v-stepper-step
                :complete="stepper > 1"
                step="1"
                editable
                :rules="[
                  () => stepper === 1 || !!serviceReport.issue_appear_method
                ]"
              >
                {{ $t(`serviceReport`) }}
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-layout wrap justify-start>
                  <v-flex xs8>
                    <v-select
                      name="issue_appear_method"
                      v-model="serviceReport.issue_appear_method"
                      :items="getAllIssueAppearMethods()"
                      :label="$t('issueAppearMethod')"
                      v-validate="'required'"
                      :data-vv-as="$t('issueAppearMethod')"
                      :error-messages="errors.collect('issue_appear_method')"
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs4
                    v-if="
                      serviceReport.issue_appear_method === 'COMPLAINT' ||
                      serviceReport.issue_appear_method === 'SERVICE' ||
                      serviceReport.issue_appear_method === 'CUSTOM_NUMBER'
                    "
                  >
                    <v-text-field
                      name="issue_appear_method_complaint_number"
                      :label="
                        serviceReport.issue_appear_method === 'CUSTOM_NUMBER'
                          ? $t('customIssueAppearMethodNumber')
                          : $t('occurrencePlaceCustomComplaintNumber')
                      "
                      type="text"
                      v-validate="
                        serviceReport.issue_appear_method === 'COMPLAINT' ||
                        serviceReport.issue_appear_method === 'SERVICE' ||
                        serviceReport.issue_appear_method === 'CUSTOM_NUMBER'
                          ? 'required|max:255'
                          : ''
                      "
                      v-model="
                        serviceReport.issue_appear_method_complaint_number
                      "
                      :data-vv-as="
                        serviceReport.issue_appear_method === 'CUSTOM_NUMBER'
                          ? $t('customIssueAppearMethodNumber')
                          : $t('occurrencePlaceCustomComplaintNumber')
                      "
                      :error-messages="
                        errors.collect('issue_appear_method_complaint_number')
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(2)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepper > 2"
                step="2"
                edit-icon="train"
                editable
                :rules="[
                  () =>
                    stepper <= 2 ||
                    (!!serviceReport.vehicle &&
                      !!serviceReport.vehicle_part &&
                      !!serviceReport.project_phase &&
                      !!serviceReport.odometer &&
                      !!serviceReport.occurrence_place)
                ]"
              >
                {{ $t("vehicle") }}
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-layout wrap justify-start>
                  <v-flex xs6>
                    <v-autocomplete
                      name="vehicle"
                      :label="$t('vehicle')"
                      :loading="vehicleIsLoading"
                      :items="vehicles"
                      v-model="serviceReport.vehicle"
                      v-validate="'required'"
                      cache-items
                      clearable
                      prepend-icon="train"
                      item-text="name"
                      item-value="id"
                      :data-vv-as="$t('vehicle')"
                      :error-messages="errors.collect('vehicle')"
                      :disabled="!!this.serviceReport.issue"
                      @input="
                        value => {
                          fetchOdometer(value);
                          fetchSpareParts(value, sparePartSearch);
                        }
                      "
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      name="vehicle_part"
                      v-model="serviceReport.vehicle_part"
                      :items="allVehicleParts"
                      :label="$t('vehiclePart')"
                      v-validate="'required'"
                      :data-vv-as="$t('vehiclePart')"
                      :error-messages="errors.collect('vehicle_part')"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      name="project_phase"
                      v-model="serviceReport.project_phase"
                      :items="getAllProjectPhases()"
                      :label="$t('projectPhase')"
                      v-validate="'required'"
                      :data-vv-as="$t('projectPhase')"
                      :error-messages="errors.collect('project_phase')"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      name="odometer"
                      v-model="serviceReport.odometer"
                      :label="$t('odometer')"
                      v-validate="'required|numeric'"
                      :data-vv-as="$t('odometer')"
                      :error-messages="errors.collect('odometer')"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      name="occurrence_place"
                      v-model="serviceReport.occurrence_place"
                      :items="getAllIssueOccurrencePlaces()"
                      :label="$t('occurrencePlace')"
                      v-validate="'required'"
                      :data-vv-as="$t('occurrencePlace')"
                      :error-messages="errors.collect('occurrence_place')"
                      :disabled="!!this.serviceReport.issue"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4 v-if="serviceReport.occurrence_place === 'OTHER'">
                    <v-text-field
                      name="occurrence_place_custom"
                      :label="$t('occurrencePlaceCustom')"
                      type="text"
                      v-validate="
                        serviceReport.occurrence_place === 'OTHER'
                          ? 'required'
                          : ''
                      "
                      v-model="serviceReport.occurrence_place_custom"
                      :data-vv-as="$t('occurrencePlaceCustom')"
                      :error-messages="
                        errors.collect('occurrence_place_custom')
                      "
                      :disabled="!!this.serviceReport.issue"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(3)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepper > 3"
                step="3"
                edit-icon="bug_report"
                editable
                :rules="[
                  () =>
                    stepper <= 3 ||
                    !!serviceReport.issue_category ||
                    !!serviceReport.issue_code ||
                    !!serviceReport.reason
                ]"
              >
                {{ $t("issue") }}
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-autocomplete
                      name="issue_category"
                      :label="$t('issueCategory')"
                      :items="getAllIssueCategories()"
                      v-model="serviceReport.issue_category"
                      :data-vv-as="$t('issueCategory')"
                      :error-messages="errors.collect('issue_category')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      name="issue_code"
                      :label="$t('issueCode')"
                      :items="dictionary.issueCodes"
                      v-model="serviceReport.issue_code"
                      :item-text="
                        item => {
                          return '(' + item.code + ') ' + item.name;
                        }
                      "
                      item-value="id"
                      :filter="itemWithCodeSearchFilter"
                      :data-vv-as="$t('issueCode')"
                      :error-messages="errors.collect('issue_code')"
                      multiple
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      name="issue_description"
                      :label="$t('issueDescription')"
                      v-model="serviceReport.issue_description"
                      :data-vv-as="$t('issueDescription')"
                      :error-messages="errors.collect('issue_description')"
                      auto-grow
                      rows="2"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      name="displayed_message"
                      v-model="serviceReport.displayed_message"
                      :label="$t('serviceReportDisplayedMessage')"
                      :data-vv-as="$t('serviceReportDisplayedMessage')"
                      :error-messages="errors.collect('displayed_message')"
                      v-validate="'max:255'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      v-model="serviceReport.has_diagnostic_report"
                      :label="$t('hasDiagnosticReport')"
                    ></v-checkbox>
                    <v-text-field
                      name="diagnostic_report_info"
                      v-model="serviceReport.diagnostic_report_info"
                      :label="$t('diagnosticReportInfo')"
                      :data-vv-as="$t('diagnosticReportInfo')"
                      :error-messages="errors.collect('diagnostic_report_info')"
                      v-if="serviceReport.has_diagnostic_report"
                      v-validate="
                        serviceReport.has_diagnostic_report
                          ? 'required|max:255'
                          : ''
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      name="reason"
                      :label="$t('reason')"
                      :items="dictionary.reasons"
                      v-model="serviceReport.reason"
                      :item-text="
                        item => {
                          return '(' + item.code + ') ' + item.name;
                        }
                      "
                      item-value="id"
                      :filter="itemWithCodeSearchFilter"
                      :data-vv-as="$t('reason')"
                      :error-messages="errors.collect('reason')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(4)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepper > 4"
                step="4"
                edit-icon="build"
                editable
                :rules="[
                  () =>
                    stepper <= 4 ||
                    !!serviceReport.repair_category ||
                    !!serviceReport.repair_code
                ]"
              >
                {{ $t("repair") }}
              </v-stepper-step>
              <v-stepper-content step="4">
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-autocomplete
                      name="repair_category"
                      :label="$t('repairCategory')"
                      :items="getAllRepairCategories()"
                      v-model="serviceReport.repair_category"
                      :data-vv-as="$t('repairCategory')"
                      :error-messages="errors.collect('repair_category')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="serviceReport.additional_repair_outside_vehicle"
                      :label="$t('additionalRepairOutsideVehicle')"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      name="repair_code"
                      :label="$t('repairCode')"
                      :items="dictionary.repairCodes"
                      v-model="serviceReport.repair_code"
                      :item-text="
                        item => {
                          return '(' + item.code + ') ' + item.name;
                        }
                      "
                      item-value="id"
                      :filter="itemWithCodeSearchFilter"
                      :data-vv-as="$t('repairCode')"
                      :error-messages="errors.collect('repair_code')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(5)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepper > 5"
                step="5"
                edit-icon="extension"
                editable
                :rules="[
                  () =>
                    stepper <= 5 ||
                    (!!serviceReport.product_group && !!serviceReport.component)
                ]"
              >
                {{ $t("component") }}
              </v-stepper-step>
              <v-stepper-content step="5">
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-autocomplete
                      name="product_group"
                      :label="$t('productGroups')"
                      :items="dictionary.productGroups"
                      v-model="serviceReport.product_group"
                      item-text="name"
                      item-value="id"
                      :data-vv-as="$t('productGroups')"
                      :error-messages="errors.collect('product_group')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      name="component"
                      :label="$t('component')"
                      :items="dictionary.components"
                      v-model="serviceReport.component"
                      item-text="name"
                      item-value="id"
                      :data-vv-as="$t('component')"
                      :error-messages="errors.collect('component')"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(6)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step
                :complete="stepper > 6"
                step="6"
                edit-icon="memory"
                editable
                :rules="[
                  () =>
                    stepper <= 6 ||
                    !partWasReplaced ||
                    serviceReport.spare_part.unreadable_serial_number ||
                    !!serviceReport.spare_part.new_part_serial_number ||
                    !!serviceReport.spare_part.to_replace
                ]"
              >
                {{ $t("faultyPart") }}
              </v-stepper-step>
              <v-stepper-content step="6">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="partWasReplaced"
                      :label="$t('partWasReplaced')"
                      :disabled="sparePartEdit.formDisabled"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md6 v-if="partWasReplaced">
                    <h4>{{ $t("faultyPart") }}</h4>
                    <v-container grid-list-xs fluid>
                      <v-layout row wrap justify-space-between>
                        <v-flex xs12>
                          <v-autocomplete
                            name="spare_part_type"
                            :label="$t('sparePartType')"
                            :loading="sparePartTypeIsLoading"
                            :items="sparePartTypes"
                            :search-input.sync="sparePartTypeSearch"
                            v-model="sparePartTypeModel"
                            cache-items
                            item-text="name"
                            item-value="id"
                            v-validate="partWasReplaced ? 'required' : ''"
                            :data-vv-as="$t('sparePartType')"
                            :error-messages="errors.collect('spare_part_type')"
                            v-if="!sparePartEdit.formDisabled"
                            @input="
                              fetchSpareParts(
                                serviceReport.vehicle,
                                sparePartSearch
                              )
                            "
                          ></v-autocomplete>
                          <v-select
                            name="spare_part_type"
                            :label="$t('sparePartType')"
                            :items="sparePartEdit.typeItems"
                            v-model="sparePartTypeModel"
                            item-text="name"
                            item-value="id"
                            v-if="sparePartEdit.formDisabled"
                            :disabled="true"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-combobox
                            name="spare_part"
                            :label="$t('serialNumber')"
                            :loading="vehicleSparePartsIsLoading"
                            :items="vehicleSpareParts"
                            :search-input.sync="sparePartSearch"
                            v-model="serviceReport.spare_part.to_replace"
                            item-text="serial_number"
                            item-value="id"
                            tags
                            v-validate="partWasReplaced && !serviceReport.spare_part.unreadable_serial_number ? 'required' : ''"
                            :data-vv-as="$t('serialNumber')"
                            :error-messages="errors.collect('spare_part')"
                            :disabled="isSparePartSerialNumberDisabled"
                            :placeholder="$t('typeOrSelectSerialNumber')"
                            v-if="!sparePartEdit.formDisabled"
                          ></v-combobox>
                          <v-select
                            name="spare_part"
                            :label="$t('serialNumber')"
                            :items="sparePartEdit.serialNumberItems"
                            v-model="sparePartEdit.serialNumberModel"
                            item-text="name"
                            item-value="id"
                            v-if="sparePartEdit.formDisabled"
                            :disabled="true"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-model="
                              serviceReport.spare_part.unreadable_serial_number
                            "
                            :label="$t('unreadableSerialNumber')"
                            :disabled="sparePartEdit.formDisabled"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-if="sparePartEdit.formDisabled">
                          <v-text-field
                            :label="$t('sparePartType')"
                            :value="sparePartTypeModel ? (sparePartEdit.typeItems[0] && sparePartEdit.typeItems[0].name) : ''"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex md6 v-if="partWasReplaced">
                    <h4>{{ $t("repairedPart") }}</h4>
                    <v-container grid-list-xs fluid>
                      <v-layout row wrap justify-space-between>
                        <v-text-field
                          name="new_part_serial_number"
                          v-model="
                            serviceReport.spare_part.new_part_serial_number
                          "
                          :label="$t('serialNumber')"
                          :data-vv-as="$t('serialNumber')"
                          :error-messages="
                            errors.collect('new_part_serial_number')
                          "
                          v-validate="partWasReplaced ? 'required|max:255' : ''"
                          :disabled="sparePartEdit.formDisabled"
                        ></v-text-field>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click="goToStep(7)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="stepper > 7" step="7" editable>
                {{ $t("worklog.name") }}
              </v-stepper-step>
              <v-stepper-content step="7">
                <au-date-time-picker
                  v-model="serviceReport.work_started_at"
                  name="work_started_at"
                  :label="$t('worklog.workStart')"
                  required
                  max-today
                />
                <au-date-time-picker
                  v-model="serviceReport.work_finished_at"
                  name="work_finished_at"
                  :label="$t('worklog.workFinish')"
                  required
                  max-today
                />
                <v-btn color="primary" @click="goToStep(8)">{{
                  $t(`continue`)
                }}</v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="stepper > 8" step="8" editable>
                {{ $t("issueItemAdditionalInfo") }}
              </v-stepper-step>
              <v-stepper-content step="8">
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea
                      name="additional_information"
                      :label="$t('additionalInformation')"
                      v-model="serviceReport.additional_information"
                      :data-vv-as="$t('additionalInformation')"
                      :error-messages="errors.collect('additional_information')"
                      auto-grow
                      rows="2"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="serviceReport.has_affect_passenger_safety"
                      :label="$t('hasAffectPassengerSafety')"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="serviceReport.vehicle_excluded"
                      :label="$t('vehicleExcluded')"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs6 v-if="serviceReport.vehicle_excluded">
                    <v-menu
                      :close-on-content-click="false"
                      v-model="vehicleExcludedFrom.menu"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        name="vehicle_excluded_from_date"
                        slot="activator"
                        :value="
                          vehicleExcludedFrom.date
                            ? $moment(vehicleExcludedFrom.date).format('LL')
                            : null
                        "
                        :label="$t('vehicleExcludedFrom')"
                        v-validate="
                          serviceReport.vehicle_excluded ? 'required' : ''
                        "
                        :data-vv-as="$t('vehicleExcludedFrom')"
                        :error-messages="
                          errors.collect('vehicle_excluded_from_date')
                        "
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="vehicleExcludedFrom.date"
                        @input="vehicleExcludedFrom.menu = false"
                        :locale="LANG"
                        reactive
                        :max="$moment().format('YYYY-MM-DD')"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6 v-if="serviceReport.vehicle_excluded">
                    <v-text-field
                      name="vehicle_excluded_from_time"
                      v-model="vehicleExcludedFrom.time"
                      v-validate="
                        serviceReport.vehicle_excluded ? 'required' : ''
                      "
                      type="time"
                      prepend-icon="access_time"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-if="serviceReport.vehicle_excluded">
                    <v-menu
                      :close-on-content-click="false"
                      v-model="vehicleExcludedUntil.menu"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        name="vehicle_excluded_until_date"
                        slot="activator"
                        :value="
                          vehicleExcludedUntil.date
                            ? $moment(vehicleExcludedUntil.date).format('LL')
                            : null
                        "
                        :label="$t('vehicleExcludedUntil')"
                        v-validate="
                          serviceReport.vehicle_excluded ? 'required' : ''
                        "
                        :data-vv-as="$t('vehicleExcludedUntil')"
                        :error-messages="
                          errors.collect('vehicle_excluded_until_date')
                        "
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="vehicleExcludedUntil.date"
                        @input="vehicleExcludedUntil.menu = false"
                        :locale="LANG"
                        reactive
                        :max="$moment().format('YYYY-MM-DD')"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6 v-if="serviceReport.vehicle_excluded">
                    <v-text-field
                      name="vehicle_excluded_until_time"
                      v-model="vehicleExcludedUntil.time"
                      v-validate="
                        serviceReport.vehicle_excluded ? 'required' : ''
                      "
                      type="time"
                      prepend-icon="access_time"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" @click.native="saveAction">{{
                  isEditView()
                    ? $t("editServiceReport")
                    : $t("createServiceReport")
                }}</v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  CREATE_SERVICE_REPORT,
  FETCH_ISSUE,
  FETCH_SERVICE_REPORT,
  FETCH_VEHICLES,
  RESET_SERVICE_REPORT,
  SHOW_SNACKBAR,
  UPDATE_SERVICE_REPORT,
  FETCH_SPARE_PART_TYPES,
  FETCH_VEHICLE_SPARE_PARTS
} from "../../store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";
import IssueCategories from "@/common/enums/issueCategory.service";
import RepairCategories from "@/common/enums/repairCategory.service";
import IssueOccurrencePlace from "@/common/enums/issueOccurrencePlace.service";
import ProjectPhases from "@/common/enums/projectPhase.service";
import IssueAppearMethods from "@/common/enums/issueAppearMethod.service";
import _ from "lodash";

export default {
  data() {
    return {
      stepper: 1,
      LANG: process.env.VUE_APP_LANG,
      vehicleSearch: "",
      sparePartTypeSearch: "",
      sparePartSearch: "",
      sparePartTypeModel: null,
      sparePartEdit: {
        formDisabled: false,
        typeItems: [],
        serialNumberItems: [],
        serialNumberModel: null
      },
      allVehicleParts: [
        {
          value: "A",
          text: "A"
        },
        {
          value: "B",
          text: "B"
        },
        {
          value: "C",
          text: "C"
        }
      ],
      vehicleExcludedFrom: {
        menu: false,
        menuTime: false,
        date: null,
        time: null
      },
      vehicleExcludedUntil: {
        menu: false,
        menuTime: false,
        date: null,
        time: null
      },
      formDisabled: false,
      partWasReplaced: false,
      breadcrumbs: [
        {
          text: this.$t("serviceReports"),
          to: { name: "ServiceReports" },
          exact: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "serviceReport",
      "vehicles",
      "vehiclesCount",
      "vehicleIsLoading",
      "dictionary",
      "issue",
      "sparePartTypes",
      "sparePartTypeIsLoading",
      "vehicleSpareParts",
      "vehicleSparePartsIsLoading"
    ]),
    title() {
      return !this.isEditView()
        ? this.$t("createServiceReport")
        : this.$t("editServiceReport") + " #" + this.serviceReport.rma;
    },
    stepToFieldNames() {
      let step6 = [];
      if (this.partWasReplaced) {
        step6 = ["spare_part_type", "spare_part", "new_part_serial_number"];
      }

      return {
        1: ["issue_appear_method", "issue_appear_method_complaint_number"],
        2: [
          "vehicle",
          "vehicle_part",
          "project_phase",
          "odometer",
          "occurrence_place",
          "occurrence_place_custom"
        ],
        3: [
          "issue_category",
          "issue_code",
          "issue_description",
          "displayed_message",
          "diagnostic_report_info",
          "reason"
        ],
        4: ["repair_category", "repair_code"],
        5: ["product_group", "component"],
        6: step6,
        7: [],
        8: [
          "additional_information",
          "vehicle_excluded_from_date",
          "vehicle_excluded_from_time",
          "vehicle_excluded_until_date",
          "vehicle_excluded_until_time"
        ]
      };
    },
    isSparePartSerialNumberDisabled() {
      // In create mode, always allow manual input regardless of vehicle/type selection
      // In edit mode, only disable if vehicle is somehow not selected (shouldn't happen)
      return this.isEditView() && _.isNil(this.serviceReport.vehicle);
    }
  },
  mixins: [validationErrorsMixin],
  watch: {
    sparePartTypeSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_SPARE_PART_TYPES, [{ rowsPerPage: -1 }, val]);
    }, 300),
    sparePartSearch: _.debounce(function(val) {
      if (this.serviceReport.vehicle) {
        this.fetchSpareParts(this.serviceReport.vehicle, val);
      }
    }, 300)
  },
  created: function() {
    this.$store.dispatch(FETCH_VEHICLES, [{ rowsPerPage: -1 }]);

    if (this.isCreateWithIssueView()) {
      this.serviceReport.issue = this.issue.id;
      this.serviceReport.vehicle = this.issue.vehicle.id;
      this.serviceReport.occurrence_place = this.issue.occurrence_place;
      this.serviceReport.occurrence_place_custom = this.issue.occurrence_place_custom;

      this.fetchOdometer(this.issue.vehicle.id);
    }

    // Initialize spare_part for both create and edit modes
    this.serviceReport.spare_part = this.serviceReport.spare_part || {};

    if (this.isEditView()) {
      this.serviceReport.vehicle = this.serviceReport.vehicle.id;

      this.partWasReplaced = !_.isNil(this.serviceReport.replaced_spare_part);

      if (this.partWasReplaced) {
        this.sparePartEdit.formDisabled = true;
        this.sparePartEdit.typeItems = [
          {
            id: this.serviceReport.replaced_spare_part.type.id,
            name: this.serviceReport.replaced_spare_part.type.name
          }
        ];
        this.sparePartEdit.serialNumberItems = [
          {
            id: this.serviceReport.replaced_spare_part.id,
            name: this.serviceReport.replaced_spare_part.serial_number
          }
        ];

        this.sparePartEdit.serialNumberModel = this.serviceReport.replaced_spare_part.id;
        this.serviceReport.spare_part.new_part_serial_number = this.serviceReport.replaced_spare_part.replaced_on.serial_number;
        this.serviceReport.spare_part.unreadable_serial_number = this.serviceReport.replaced_spare_part.unable_to_read_serial_number_properly;
        this.sparePartTypeModel = this.serviceReport.replaced_spare_part.type.id;
      }
    }

    if (this.serviceReport.vehicle_excluded_from) {
      this.serviceReport.vehicle_excluded = true;
      let moment = this.$moment(this.serviceReport.vehicle_excluded_from);
      this.vehicleExcludedFrom.date = moment.format("YYYY-MM-DD");
      this.vehicleExcludedFrom.time = moment.format("HH:mm");
    }
    if (this.serviceReport.vehicle_excluded_until) {
      this.serviceReport.vehicle_excluded = true;
      let moment = this.$moment(this.serviceReport.vehicle_excluded_until);
      this.vehicleExcludedUntil.date = moment.format("YYYY-MM-DD");
      this.vehicleExcludedUntil.time = moment.format("HH:mm");
    }
  },
  methods: {
    isCreateWithIssueView() {
      return !!this.$route.params.issueId;
    },
    isEditView() {
      return !!this.$route.params.id;
    },
    getAllIssueCategories() {
      return IssueCategories.getAll();
    },
    getAllRepairCategories() {
      return RepairCategories.getAll();
    },
    getAllIssueOccurrencePlaces() {
      return IssueOccurrencePlace.getAll();
    },
    getAllProjectPhases() {
      return ProjectPhases.getAll();
    },
    getAllIssueAppearMethods() {
      return IssueAppearMethods.getAll();
    },
    itemWithCodeSearchFilter(item, queryText) {
      const searchText = queryText.toLowerCase();

      return (
        item.name.toLowerCase().indexOf(searchText) > -1 ||
        item.code.toLowerCase().indexOf(searchText) > -1
      );
    },
    goToStep(step) {
      const currentStep = step - 1;
      Promise.all(
        this.stepToFieldNames[currentStep].map(fieldName => {
          return this.$validator.fields.find({ name: fieldName })
            ? this.$validator.validate(fieldName)
            : true;
        })
      ).then(value => {
        if (_.every(value)) {
          this.stepper = step;
        }
      });
    },
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;

          if (this.serviceReport.vehicle_excluded) {
            this.serviceReport.vehicle_excluded_from = this.$moment(
              this.vehicleExcludedFrom.date +
                " " +
                this.vehicleExcludedFrom.time
            ).format();
            this.serviceReport.vehicle_excluded_until = this.$moment(
              this.vehicleExcludedUntil.date +
                " " +
                this.vehicleExcludedUntil.time
            ).format();
          }

          if (_.isObject(this.serviceReport.vehicle)) {
            this.serviceReport.vehicle = this.serviceReport.vehicle.id;
          }
          if (_.isObject(this.serviceReport.component)) {
            this.serviceReport.component = this.serviceReport.component.id;
          }
          if (_.isObject(this.serviceReport.product_group)) {
            this.serviceReport.product_group = this.serviceReport.product_group.id;
          }
          if (_.isObject(this.serviceReport.reason)) {
            this.serviceReport.reason = this.serviceReport.reason.id;
          }
          if (_.isObject(this.serviceReport.repair_code)) {
            this.serviceReport.repair_code = this.serviceReport.repair_code.id;
          }
          this.serviceReport.issue_code = this.serviceReport.issue_code.map(
            value => {
              return _.isObject(value) ? value.id : value;
            }
          );
          this.serviceReport.spare_part = this.serviceReport.spare_part || {};
          this.serviceReport.spare_part.type = this.sparePartTypeModel;

          this.$store
            .dispatch(
              this.isEditView() ? UPDATE_SERVICE_REPORT : CREATE_SERVICE_REPORT,
              this.serviceReport
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("serviceReport")]),
                color: "success"
              });

              this.$store.dispatch(RESET_SERVICE_REPORT);
              this.$refs.editCreateForm.reset();
              this.$validator.reset();
              this.$router.push({ name: "ServiceReports" });
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    fetchOdometer(vehicleId) {
      if (vehicleId) {
        this.serviceReport.odometer = this.vehicles.find(
          vehicle => vehicle.id === vehicleId
        ).odometer;
      } else {
        this.serviceReport.odometer = null;
      }
    },
    fetchSpareParts(vehicleId, search) {
      if (vehicleId && this.sparePartTypeModel) {
        this.$store.dispatch(FETCH_VEHICLE_SPARE_PARTS, [
          vehicleId,
          { rowsPerPage: -1 },
          search,
          {
            type: this.sparePartTypeModel
          }
        ]);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_SERVICE_REPORT);
    if (to.params.id) {
      Promise.all([store.dispatch(FETCH_SERVICE_REPORT, to.params.id)]).then(
        () => {
          next();
        }
      );
    } else if (to.params.issueId) {
      Promise.all([
        store.dispatch(FETCH_ISSUE, to.params.issueId),
        store.dispatch(FETCH_VEHICLES, [{ rowsPerPage: -1 }, ""])
      ]).then(() => {
        next();
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped></style>
